import {
  ScanIqCustomerSetupPersonalData,
  ScanIqCustomerSetupInfo,
} from '../interfaces/ScanIqCustomerSetupInfo';
import { apiService } from '../../shared/services/apiService';
import { ScanIqCustomerListInfo } from '../interfaces/ScanIqCustomerListInfo';
import { SpringPagination } from '../../shared/interfaces/SpringPagination';
import { ScanIqCustomerListFilters } from '../interfaces/ScanIqCustomerListFilters';
import { getFilteredTruthyFieldsObj } from '../../shared/utils/sortingAndGroupingUtil';

type GetCustomerListResponse = SpringPagination<ScanIqCustomerListInfo[]>;

export const scanIqCustomerService = {
  async getCustomerList(
    params: ScanIqCustomerListFilters,
  ): Promise<GetCustomerListResponse> {
    const filteredParams = getFilteredTruthyFieldsObj(params);

    const response = await apiService.post(
      '/api/data-filters/communication/scan-iq/customers',
      filteredParams,
    );

    return response.data;
  },

  async updateCustomer(
    customer: ScanIqCustomerSetupPersonalData,
  ): Promise<ScanIqCustomerSetupInfo> {
    const response = await apiService.put(
      '/api/scan-iq/customer/personal-data',
      customer,
    );

    return response.data;
  },
};
